module.exports = __webpack_public_path__ + "static/media/default-house.5e644e86.png";